import Axios from "axios"
import { region } from "consumer/setup/region"


export async function get_academy_list(props) {

    const set = props['set']

    const searchRegion = props['searchRegion']
    const Set_searchRegion = props['Set_searchRegion']

    const searchAddress = props['searchAddress']
    const Set_searchAddress = props['Set_searchAddress']

    const Set_regionList = props['Set_regionList']
    const Set_addressList = props['Set_addressList']
    const Set_academyList = props['Set_academyList']

    const Set_addressLoading = props['Set_addressLoading']
    const Set_academyLoading = props['Set_academyLoading']

    const res = await Axios
                .post("/academy/list", {
                    set: set,
                    region: searchRegion,
                    address: searchAddress
                })

    if(set === "region") {
        const list = res.data.list
        const new_region_list = []
        for(let i=0; i<region.length; i++) {
            const a = list.findIndex(x => x['Sido'].indexOf(region[i]) !== -1)
            if(a !== -1) {
                new_region_list.push(region[i])
            }
        }
        if(new_region_list.length !== 0) {
            Set_searchRegion(new_region_list[0])
        }
        else if(new_region_list.length === 0) {
            Set_addressList([])

            Set_addressLoading(false)
        }
        Set_regionList(new_region_list)
    }
    else if(set === "address") {
        const new_address_list = [];
        const list = res.data.list;
        for(let i=0; i<res.data.count; i++) {
            const address = list[i]["Addr1"].split(" ")[1].trim();
            if(!new_address_list.includes(address) && address !== "") {
                new_address_list.push(address);
            }
        }

        Set_searchAddress("");

        Set_addressList(new_address_list);
        Set_academyList([]);

        Set_addressLoading(false)
    }
    else if(set === "academy") {
        Set_academyList(res.data.list);

        Set_academyLoading(false)
    }
}